import ReactDOM from 'react-dom'

export default function RyderLivescoringModalPortal({ children }) {
    return ReactDOM.createPortal(children, document.body)
}
